import { useLayoutEffect, useMemo } from "react";
import i18n from "../utils/language/i18n";
import { getAnmalningLangFromSearch } from "../utils/anmalningPublicLink";

/**
 * Applies ?lang= from a public anmälning URL to i18n (and localStorage).
 * useLayoutEffect so copy is correct before the response card paints.
 * @param {string} search
 * @returns {"sv"|"en"|"pt"|"es"|null}
 */
export default function useAnmalningLinkLanguage(search) {
  const lang = useMemo(() => getAnmalningLangFromSearch(search), [search]);

  useLayoutEffect(() => {
    if (!lang) return;
    if (i18n.language !== lang && i18n.resolvedLanguage !== lang) {
      i18n.changeLanguage(lang);
    }
    try {
      localStorage.setItem("language", lang);
    } catch {
      /* ignore */
    }
  }, [lang]);

  return lang;
}
